import { useAuth } from '../contexts/AuthContext';

/**
 * Hook to check if user is unverified.
 * Use this to skip API calls for unverified users.
 *
 * Usage:
 * const { isUnverified } = useVerificationGuard();
 *
 * const loadData = useCallback(async () => {
 *   if (isUnverified) {
 *     setLoading(false);
 *     return;
 *   }
 *   // API calls here
 * }, [isUnverified]);
 */
export const useVerificationGuard = () => {
  const { user } = useAuth();
  const isUnverified = user?.role === 'UNVERIFIED_USER';

  return { isUnverified };
};
